"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { useIntlayer } from "next-intlayer";

export default function CTASection() {
  const { title, body, cta } = useIntlayer("cta-section");

  return (
    <section className="py-24 px-4 text-center" style={{ background: "#016ea4" }}>
      <div className="max-w-3xl mx-auto">
        <motion.h2
          className="text-4xl md:text-5xl font-semibold text-white mb-6 leading-tight"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          {title}
        </motion.h2>

        <motion.p
          className="text-lg mb-10"
          style={{ color: "rgba(255,255,255,0.75)" }}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15, ease: "easeOut" }}
        >
          {body}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3, ease: "easeOut" }}
        >
          <motion.div whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }}>
            <Link
              href="/courses"
              className="inline-block px-10 py-4 rounded-full font-semibold text-lg transition-shadow hover:shadow-xl"
              style={{ background: "#ffffff", color: "#016ea4" }}
            >
              {cta}
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
